import script from "./NotificationConfigView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationConfigView.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationConfigView.vue?vue&type=style&index=0&id=5668abad&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5668abad"]])

export default __exports__